const noop = () => {}

module.exports = {
    reportActionStart: noop,
    reportActionEnd: noop
}
